import React from 'react';
import { useTranslation } from 'react-i18next';

import {
	IntroContentStyled,
	IntroDescriptionStyled,
	IntroImageMStyled,
	IntroImageStyled,
	IntroImageTStyled,
	IntroStyled,
	IntroTextContainerStyled,
	IntroTextStyled,
} from './ApplicationsIntro.styles';

export const ApplicationsIntro: React.FC = () => {
	const { t } = useTranslation();

	return (
		<IntroStyled>
			<IntroContentStyled>
				<IntroTextContainerStyled>
					<IntroTextStyled strong>{t(`Marketplace_Intro_Heading`)}</IntroTextStyled>
					<IntroDescriptionStyled>{t(`Marketplace_Intro_Description`)}</IntroDescriptionStyled>
				</IntroTextContainerStyled>
				<IntroImageStyled src='https://cdn.dodostatic.net/static/marketplace/home/bg-d' />
				<IntroImageTStyled src='https://cdn.dodostatic.net/static/marketplace/home/bg-t' />
				<IntroImageMStyled src='https://cdn.dodostatic.net/static/marketplace/home/bg-sm-992-1' />
			</IntroContentStyled>
		</IntroStyled>
	);
};
